import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import portalService from '../../services/portalService';
import { useLanguage, t } from '../../context/LanguageContext';

function periodBounds() {
  const now = new Date();
  const day = now.getDate();
  const y = now.getFullYear(), m = now.getMonth();
  const from = day <= 15 ? new Date(y, m, 1) : new Date(y, m, 16);
  const to   = day <= 15 ? new Date(y, m, 15) : new Date(y, m + 1, 0);
  return {
    from: from.toISOString().split('T')[0],
    to:   to.toISOString().split('T')[0],
  };
}

export default function PortalDashboardPage() {
  const { lang } = useLanguage();
  const [pto, setPto] = useState(null);
  const [pay, setPay] = useState(null);
  const [points, setPoints] = useState(null);
  const [pendingRequests, setPendingRequests] = useState(0);

  useEffect(() => {
    const { from, to } = periodBounds();
    Promise.all([
      portalService.getPto().catch(() => null),
      portalService.getPay(from, to).catch(() => null),
      portalService.getPoints().catch(() => null),
    ]).then(([ptoData, payData, ptsData]) => {
      setPto(ptoData);
      setPay(payData);
      setPoints(ptsData);
      if (ptoData) setPendingRequests((ptoData.requests || []).filter(r => r.status === 'pending').length);
    });
  }, []);

  const pointColor = (p) => p >= 90 ? '#198754' : p >= 75 ? '#ffc107' : '#dc3545';

  return (
    <div>
      <h5 className="fw-bold mb-3">{t('Dashboard', 'Panel principal', lang)}</h5>

      <div className="row g-3 mb-3">
        {/* PTO */}
        <div className="col-6">
          <Link to="/portal/pto" className="text-decoration-none">
            <div className="card h-100">
              <div className="card-body p-3">
                <div className="text-muted" style={{ fontSize: 11, textTransform: 'uppercase', letterSpacing: 0.5 }}>{t('PTO Remaining', 'Vacaciones restantes', lang)}</div>
                <div className="fw-bold mt-1" style={{ fontSize: 22, color: '#0d6efd' }}>
                  {pto ? `${pto.ptoBal?.remaining ?? '—'} h` : '—'}
                </div>
                {pendingRequests > 0 && (
                  <div style={{ fontSize: 11, color: '#f0ad4e' }}>
                    {pendingRequests} {pendingRequests > 1 ? t('requests pending', 'solicitudes pendientes', lang) : t('request pending', 'solicitud pendiente', lang)}
                  </div>
                )}
              </div>
            </div>
          </Link>
        </div>

        {/* Sick */}
        <div className="col-6">
          <Link to="/portal/pto" className="text-decoration-none">
            <div className="card h-100">
              <div className="card-body p-3">
                <div className="text-muted" style={{ fontSize: 11, textTransform: 'uppercase', letterSpacing: 0.5 }}>{t('Sick Remaining', 'Enfermedad restante', lang)}</div>
                <div className="fw-bold mt-1" style={{ fontSize: 22, color: '#0d6efd' }}>
                  {pto ? `${pto.sickBal?.remaining ?? '—'} h` : '—'}
                </div>
              </div>
            </div>
          </Link>
        </div>

        {/* Pay this period */}
        <div className="col-6">
          <Link to="/portal/pay" className="text-decoration-none">
            <div className="card h-100">
              <div className="card-body p-3">
                <div className="text-muted" style={{ fontSize: 11, textTransform: 'uppercase', letterSpacing: 0.5 }}>{t('This Period', 'Este período', lang)}</div>
                <div className="fw-bold mt-1" style={{ fontSize: 22, color: '#198754' }}>
                  {pay?.totalNetHours != null ? `${pay.totalNetHours} h` : '—'}
                </div>
                <div style={{ fontSize: 11, color: '#6c757d' }}>{t('hours worked', 'horas trabajadas', lang)}</div>
              </div>
            </div>
          </Link>
        </div>

        {/* Points */}
        <div className="col-6">
          <Link to="/portal/points" className="text-decoration-none">
            <div className="card h-100">
              <div className="card-body p-3">
                <div className="text-muted" style={{ fontSize: 11, textTransform: 'uppercase', letterSpacing: 0.5 }}>{t('Points', 'Puntos', lang)}</div>
                {points ? (
                  <>
                    <div className="fw-bold mt-1" style={{ fontSize: 22, color: pointColor(points.currentPoints) }}>
                      {points.currentPoints} / {points.startingPoints}
                    </div>
                    {points.bonus && <div style={{ fontSize: 11, color: '#6c757d' }}>{t('Bonus', 'Bono', lang)}: {points.bonus.pct}% {t('tier', 'nivel', lang)}</div>}
                  </>
                ) : <div className="fw-bold mt-1" style={{ fontSize: 22 }}>—</div>}
              </div>
            </div>
          </Link>
        </div>
      </div>

      {pendingRequests > 0 && (
        <div className="alert alert-warning d-flex align-items-center justify-content-between py-2" style={{ fontSize: 13 }}>
          <span>
            {t('You have', 'Tiene', lang)} {pendingRequests} {pendingRequests > 1
              ? t('pending time-off requests.', 'solicitudes de tiempo libre pendientes.', lang)
              : t('pending time-off request.', 'solicitud de tiempo libre pendiente.', lang)}
          </span>
          <Link to="/portal/pto" className="btn btn-sm btn-warning">{t('View', 'Ver', lang)}</Link>
        </div>
      )}
    </div>
  );
}
